import useCheckToken from 'hooks/app/useCheckToken';
import useRedirect from 'hooks/app/useRedirect';
import useSetWorkspaceCode from 'hooks/app/useSetWorkspaceCode';
import { useGetUserDataQuery } from 'hooks/queries/user';
import useInitDataDog from 'hooks/useInitDataDog';
import PageRouter from 'pages/PageRouter';
import { ReactQueryDevtools } from 'react-query/devtools';
import CoreToast from 'shared/CoreToast';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import './styles/global.css';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import '@styles/vanilla-extract/theme.css';

const PageBox = styled.div`
	width: 100%;
	height: 100vh;
	overflow: hidden;
`;

function App() {
	// store
	const { mount, text, permanant, is_error } = useCommonStore(
		(state) => state.toast_data,
	);
	const setMount = useCommonStore((state) => state.setToastData);

	// hooks
	useCheckToken();
	useSetWorkspaceCode();
	useRedirect();
	useInitDataDog();

	return (
		<>
			<PageBox>
				<PageRouter />
				<CoreToast
					text={text}
					permanent={permanant}
					mount={mount}
					is_error={is_error}
					setMount={(value: boolean | string) => setMount('mount', value)}
					max_width="800px"
				/>
			</PageBox>
			<ReactQueryDevtools initialIsOpen={false} />
		</>
	);
}

export default App;
